import { SIGNUP_ERROR_CODES, useOffers } from '../../hooks/useOffers';
import { OffersLoader } from '../../ProductOffers/OffersLoader/OffersLoader';
import { CheckDetailsForm } from '../CheckDetailsForm/CheckDetailsForm';
import { useCheckDetails } from '../useCheckDetails';

export const CheckDetailsWrapper = () => {
  const { dataRequirementErrors } = useOffers({
    getOffersEnabled: true,
  });

  const {
    isLoading,
    normalisedState,
    updateStateData,
    applicantDOBMatchesCompaniesHouse,
  } = useCheckDetails();

  const hasApplicantDetailsError = dataRequirementErrors?.some((error) =>
    SIGNUP_ERROR_CODES.CONFIRM_APPLICANT_DETAILS.includes(error.code),
  );

  const hasCreditCheckError = dataRequirementErrors?.some((error) =>
    SIGNUP_ERROR_CODES.CREDIT_CHECK.includes(error.code),
  );

  const hasEquifaxTokenOnPrimaryAddress =
    !!normalisedState.applicant?.residentialAddresses?.[0]?.equifax_token;

  if (!dataRequirementErrors || isLoading) {
    return <OffersLoader />;
  }

  return (
    <CheckDetailsForm
      normalisedState={normalisedState}
      hasApplicantDetailsError={
        hasApplicantDetailsError || !applicantDOBMatchesCompaniesHouse()
      }
      hasCreditCheckError={hasCreditCheckError}
      hasEquifaxTokenOnPrimaryAddress={hasEquifaxTokenOnPrimaryAddress}
      updateStateData={updateStateData}
    />
  );
};
